import React, { FC, useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Tab } from '@nhl/nhl-breakaway-ui';

import { Measure } from '~/core/types';
import { commonMessages } from '~/utility/commonMessages';

import LeaderList from './components/leaderList';

import {
    Header,
    Module,
    RequirementsLabel,
    RightArrow,
    StyledTabBar,
    TitleAndCategories,
    TitleHeader,
    TitleInfo,
    TitleLink,
} from './styles';

type LeaderModuleProps = {
    measures: Array<Measure>;
    requirements?: {
        name: string;
        value: number;
    };
    seasonId?: number;
    sendGaEvent: (value: string) => void;
    title: string;
};

const LeaderModule: FC<LeaderModuleProps> = ({ measures, requirements, seasonId, sendGaEvent, title }) => {
    const intl = useIntl();

    const [activeCategory, setActiveCategory] = useState(measures && measures[0].measure);
    const [activeLeaderIndex, setActiveLeaderIndex] = useState(0);
    const activeMeasure = measures.find((obj) => obj.measure === activeCategory);

    const tabs: Array<Tab> = measures.map((measure) => ({
        key: measure.measure,
        label: intl.formatMessage(commonMessages.labels[measure.measure]),
        ariaControlId: `${measure.measure}-tabpanel`,
    }));

    const onSelectTab = (tab) => {
        setActiveCategory(tab.key);
        sendGaEvent('tab');
    };

    return (
        <Module>
            <Header>
                <TitleAndCategories>
                    <TitleLink to={activeMeasure ? decodeURIComponent(activeMeasure.allLeadersLink) : ''}>
                        <TitleHeader aria-level={2}>
                            <FormattedMessage {...commonMessages.labels[title]} />
                            <RightArrow />
                        </TitleHeader>
                    </TitleLink>
                    <TitleInfo>
                        {
                            // requirements refers to the requirements to be on the list of leaders. Ex. Goalie 25 GP+
                            requirements?.name && (
                                <RequirementsLabel>
                                    <FormattedMessage
                                        {...commonMessages.labels[requirements.name]}
                                        values={{ val: requirements.value }}
                                    />
                                </RequirementsLabel>
                            )
                        }
                    </TitleInfo>
                </TitleAndCategories>
                <StyledTabBar
                    tabs={tabs}
                    selectedTab={tabs.find((tab) => tab.key === activeCategory) || tabs[0]}
                    onChangeSelectedTab={onSelectTab}
                    className="stats"
                />
            </Header>
            {activeMeasure && (
                <LeaderList
                    activeCategory={activeCategory}
                    activeLeaderIndex={activeLeaderIndex}
                    activeMeasure={activeMeasure}
                    setActiveLeaderIndex={setActiveLeaderIndex}
                    seasonId={seasonId}
                />
            )}
        </Module>
    );
};

export default React.memo(LeaderModule);
